import React from 'react';

const ImpersonationBanner = () => {
  const isImpersonating = localStorage.getItem('impersonating') === 'true';
  if (!isImpersonating) return null;

  const handleReturnToAdmin = () => {
    const adminToken = localStorage.getItem('admin_backup_token');
    const adminUser = localStorage.getItem('admin_backup_user');
    if (adminToken && adminUser) {
      localStorage.setItem('token', adminToken);
      localStorage.setItem('user', adminUser);
      localStorage.removeItem('admin_backup_token');
      localStorage.removeItem('admin_backup_user');
      localStorage.removeItem('impersonating');
      window.location.href = '/admin';
    }
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm font-medium shadow-lg" data-testid="impersonation-banner">
      <span>Viewing as: <strong>{user.name}</strong> ({user.role})</span>
      <button
        onClick={handleReturnToAdmin}
        className="px-4 py-1 bg-white text-amber-700 rounded-lg font-bold text-xs hover:bg-amber-50 transition-colors"
        data-testid="return-to-admin-btn"
      >
        Return to Admin
      </button>
    </div>
  );
};

export default ImpersonationBanner;
